export default function NavLinks() {
	var currentUrl = window.location.pathname;
	var navLinks = document.querySelectorAll('.nav-links__link');
	navLinks.forEach(function(navLink) {
		 var href = navLink.getAttribute('href');
		 if(href && currentUrl.startsWith(href)) {
			  navLink.parentNode.classList.add('active');
		 }
	});
}
